module.exports = __webpack_public_path__ + "img/rock-huge-12.91fcce2b.png";